import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment,
} from 'react';
import Tooltip from '@mui/material/Tooltip';

export const SetCell = ({ props }: { props: any }): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (
      divWidth['element'] > divWidth['cell'] ||
      (props.value?.status_lamp && props.value?.icon)
    ) {
      setTooltip(true);
    }
  });
  const tags = props.value;

  if (tags === undefined || tags === null) {
    return <></>;
  }

  const names = tags.map(function (item: any) {
    return item?.name ? item?.name : '-';
  });

  return (
    <div
      ref={divRef}
      className={`${tooltip ? 'has-tooltip' : 'doesnthave-tooltip'}`}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={tags.map(function (item: any, index: number) {
              const name = item?.phone
                ? `${item?.name ? item?.name : '-'} (${item.phone})`
                : item?.name
                  ? item?.name
                  : '-';

              return <div key={index}>{name}</div>;
            })}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {names.join(', ')}
            </div>
          </Tooltip>
        </>
      ) : (
        <>{names.join(', ')}</>
      )}
    </div>
  );
};